export const LANGUAGES = [
  { code: "en", label: "English", english: "English" },
  { code: "cy", label: "Cymraeg", english: "Welsh" },
  { code: "ga", label: "Gaeilge", english: "Irish" },
  { code: "gd", label: "Gàidhlig", english: "Scottish Gaelic" },
  { code: "es", label: "Español", english: "Spanish" },
  { code: "fr", label: "Français", english: "French" },
  { code: "de", label: "Deutsch", english: "German" },
  { code: "it", label: "Italiano", english: "Italian" },
  { code: "pt", label: "Português", english: "Portuguese" },
  { code: "pl", label: "Polski", english: "Polish" },
  { code: "ro", label: "Română", english: "Romanian" },
  { code: "ar", label: "العربية", english: "Arabic" },
  { code: "zh-CN", label: "简体中文", english: "Chinese (Simplified)" },
  { code: "hi", label: "हिन्दी", english: "Hindi" },
  { code: "ur", label: "اردو", english: "Urdu" },
  { code: "pa", label: "ਪੰਜਾਬੀ", english: "Punjabi" },
];

const CONTAINER_ID = "google_translate_element";
const SCRIPT_SRC = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
const wait = (ms) => new Promise((r) => setTimeout(r, ms));
let loadPromise;

const createWidget = () => {
  const el = document.getElementById(CONTAINER_ID);
  if (!el || el.childElementCount > 0 || !window.google?.translate?.TranslateElement) return;
  new window.google.translate.TranslateElement(
    {
      pageLanguage: "en",
      includedLanguages: LANGUAGES.map((l) => l.code).join(","),
      autoDisplay: false,
    },
    CONTAINER_ID
  );
};

const getCombo = () => document.querySelector(`#${CONTAINER_ID} select.goog-te-combo`);

const waitFor = async (check, timeout, step = 200) => {
  for (let t = 0; t < timeout; t += step) {
    if (check()) return true;
    await wait(step);
  }
  return Boolean(check());
};

export const loadGoogleTranslate = () => {
  if (!loadPromise) {
    loadPromise = new Promise((resolve, reject) => {
      if (window.google?.translate?.TranslateElement) return resolve();
      const timer = setTimeout(() => reject(new Error("timeout")), 12000);
      window.googleTranslateElementInit = () => { clearTimeout(timer); resolve(); };
      const script = document.createElement("script");
      script.src = SCRIPT_SRC;
      script.async = true;
      script.onerror = () => reject(new Error("blocked"));
      document.body.appendChild(script);
    }).catch((err) => {
      loadPromise = undefined;
      document.querySelectorAll(`script[src="${SCRIPT_SRC}"]`).forEach((s) => s.remove());
      throw err;
    });
  }
  return loadPromise.then(async () => {
    createWidget();
    if (!(await waitFor(() => getCombo(), 6000))) throw new Error("widget");
  });
};

export const getCurrentLanguage = () => {
  const htmlLang = document.documentElement.lang;
  if (/translated-(ltr|rtl)/.test(document.documentElement.className) && LANGUAGES.some((l) => l.code === htmlLang)) return htmlLang;
  const match = document.cookie.match(/(?:^|;\s*)googtrans=\/[^/]*\/([^;]+)/);
  const code = match ? decodeURIComponent(match[1]) : "en";
  return LANGUAGES.some((l) => l.code === code) ? code : "en";
};

const isTranslated = () => /translated-(ltr|rtl)/.test(document.documentElement.className);

const clearTranslateCookies = () => {
  const host = window.location.hostname;
  const expire = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
  document.cookie = expire;
  document.cookie = `${expire}; domain=${host}`;
  document.cookie = `${expire}; domain=.${host}`;
};

const selectInCombo = (code) => {
  const combo = getCombo();
  if (!combo) return false;
  combo.value = code;
  combo.dispatchEvent(new Event("change", { bubbles: true }));
  return true;
};

// Resolves true only once the page is actually in the requested language.
export const applyLanguage = async (code) => {
  if (code === "en") {
    if (!isTranslated() && getCurrentLanguage() === "en") return true;
    selectInCombo("en");
    if (await waitFor(() => !isTranslated(), 3000)) {
      clearTranslateCookies();
      return true;
    }
    clearTranslateCookies();
    window.location.reload();
    return new Promise(() => {});
  }
  if (!selectInCombo(code)) return false;
  return waitFor(() => isTranslated() && document.documentElement.lang === code, 10000);
};
